/**
 * Analytics module - shared numerical and calculus utilities for graphpad features.
 */

// Numerical methods (root finding, intersection)
export { bisection, findRoots, findIntersections, DEFAULT_NUMERICAL_CONFIG } from './numerical-methods';
export type { NumericalConfig } from './numerical-methods';

// Interval data structures
export { interval, formatInterval, formatIntervals } from './intervals';
export type { Interval, SignedInterval, Sign } from './intervals';

// Calculus analysis (sign analysis, monotonicity, concavity)
export {
  analyzeSign,
  analyzeDomain,
  analyzeRange,
  findMonotonicityIntervals,
  findConcavityIntervals,
} from './calculus';
export type { MonotonicityInterval, ConcavityInterval } from './calculus';
